import React from 'react';
import { ReadLotacaoDto } from '@/api.types';
import { UseFormRegister } from 'react-hook-form';

interface Props {
  register: UseFormRegister<ReadLotacaoDto>;
}

export const VinculoAnotacoesCard: React.FC<Props> = ({ register }) => {
  return (
    <div className="card">
      <div className="card-header text-center">Anotações Adicionais</div>
      <div className="card-body row">
        <div className="col-md-6" title="Anotação 1">
          <input
            id="anotacao1"
            type="text"
            className="form-control"
            {...register('anotacao1')}
          />
        </div>
        <div className="col-md-6" title="Anotação 2">
          <input
            id="anotacao2"
            type="text"
            className="form-control"
            {...register('anotacao2')}
          />
        </div>
        <span className="blockquote-footer text-start mt-2 mb-0 pb-0">
          As anotações são visíveis nos relatórios.
        </span>
      </div>
    </div>
  );
};
